import cred_ars from '../../assets/cred_ars.png'
import fluxo_ar from '../../assets/credenciamento_ARs_detalhado.png'
import './ajuda.css';

export default function Ajuda(){
    return(
        <div className='ajuda'>
            <h1>Autoridades de Registro</h1>
            <p>O processo de credenciamento de Autoridades de Registro encontra-se bem definido nas etapas mostradas abaixo:</p>
            <img src={cred_ars}></img>
            Para maiores detalhes, acesse o fluxo completo de<a href={fluxo_ar}> Autoridades de Registro</a>
            <hr/>
            <h2>Estados</h2>
            <ul>
                <h5 className='protocolo'>Protocolo</h5>
                <p>Início do pedido de credenciamento, onde ocorre a abertura do processo e anexação da documentação recebida a este.</p>
                <h5 className='analise'>Análise</h5>
                <p>Etapa na qual serão analisados a documentação e os requisitos técnicos e fiscais da entidade; podendo haver geração de 
                pendências, caso a documentação entregue não esteja em conformidade, seja insuficiente ou não atenda às exigências.*</p>
                <h5 className='despachocgafi'>Despacho CGAFI</h5>
                <p>Etapa na qual as entidades são notificadas do deferimento ou do indeferimento das solicitações. No caso de credenciamento
                de AC's, essa etapa representa a análise da documentação final solicitada para o credenciamento.</p>
                <h5 className='despachodafn'>Despacho DAFN</h5>
                <p>Etapa na qual se aguarda o despacho pelo(a) Diretor(a) de Auditoria, Fiscalização e Normalização. Após o despacho, o pedido
                de credenciamento da entidade seguirá para apreciação do Diretor-Presidente.</p>
                <h5 className='despachopres'>Despacho Presidência</h5>
                <p>Etapa na qual o pedido de credenciamento será apreciado pelo Diretor-Presidente. Em caso de deferimento, o credenciamento
                será publicado no Diário Oficial da União, e a entidade se encontrará vinculada à ICP-Brasil.</p>
            </ul><br/>
            <p>*Nas etapas sujeitas a geração de pendências, caso estas não sejam solucionadas dentro dos prazos estipulados no DOC-ICP-03,
            os processos relativos ao credenciamento das entidades estão passíveis a serem arquivados.</p>
        </div>
    )
}